/* eslint-disable jsx-a11y/anchor-has-content */
import React, { Component } from "react";
import { connect } from "react-redux";
import Draggable from "react-draggable";
import Route from "./route";

import "./App.css";
import "./css/bootstrap.min.css";
import "./css/style.css";
import "./css/splashpopup.css";

import "./css/color.css";
import "./css/images.css";
import "./css/loginb2c.css";
import "./css/joinnow.css";
// import './css/login.css'
// import './css/login2.css'
import "./css/exchange.css";
import "./css/responsive.css";
import "./css/jquery.treeview.css";
import "./css/font-awesome.min.css";
import "./css/sportsbattle.css";
import "./fonts/flaticon.css";
import "./fonts/inplay-style.css";
import socketIOClient from "socket.io-client";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { SOCKET_ROOT as ENDPOINT } from "./configs/api";
import {
  ALLPAGEDISPLAYTELEGRAM,
  ALLPAGEDISPLAYWHATSAPP,
  ALLPAGEDISPLAYWHATSAPPSUPPORT,
  ALLPAGEDISPLAYWHATSAPPACCOUNT,
  ALLPAGEDISPLAYFEEDBACKWHATSAPPT,
  ALLPAGEDISPLAYFEEDBACKEMAIL,
  APK_FILE_NAME,
  TOPHEADERDOWNLOADAPKBNNR,
} from "./configs/apkFileName";
import { staticContentsImagePath as BASE_IMAGE_PATH } from "./configs/const";
import UnderMaintenance from "./components/under_maintenance";
import * as utilService from "./services/utilService";
import DisableDevtool from "disable-devtool";
import * as ustrcchk from "./util/ustrcchk.js";
// import * as Sentry from "@sentry/react"

let accessToken = !!localStorage.getItem("userAuthDetail")
  ? JSON.parse(localStorage.getItem("userAuthDetail")).token
  : "";
let socket = null;
const MySwal = withReactContent(Swal);
if (accessToken !== "") {
  let timeStemp = new Date().getTime();
  let user = JSON.parse(localStorage.getItem("tokenData"));
  let cid = !!user ? user.sub + "_" + timeStemp : "";
  socket = socketIOClient(ENDPOINT, {
    query: "token=" + accessToken + "&cid=" + cid,
    transports: ["websocket"],
  });
}

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inMaitanence: false,
      inMaitanenceMessage: "",
      clientWidth: document.documentElement.clientWidth,
      showTopHeaderApkDwnld: true,
      socialMedia: null,
    };
  }
  componentWillMount() {
    utilService.checkMaintainanceCall().then((res) => {
      if (res.isSuccess && !!res.items && res.items.isMaintenance) {
        this.setState({
          inMaitanence: true,
          inMaitanenceMessage: res.items,
        });
      }
    });
  }

  componentDidMount() {
    this.getOperatorSocialMediaListData();
    this.taskWinnerEventDicJsonRLT();
    const self = this;
    if (window.location.pathname !== "/") {
      if (!ustrcchk.chkallw()) {
        const option = {
          ondevtoolopen() {
            // document.getElementById('liDisconnectBtn')?.click();
            self.logoutFnCall();
          },
        };
        DisableDevtool(option);
      }
    } else {
      if (!ustrcchk.chkallw()) {
        const option = {
          ondevtoolopen() {
            window.location.reload();
          },
        };
        DisableDevtool(option);
      }
    }
  }

  taskWinnerEventDicJsonRLT(){

    let winnereventdic = localStorage.getItem("winnereventdic");//, JSON.stringify(data))
    let winnereventdiccondition = true;
    if(!!winnereventdic){
      winnereventdic = JSON.parse(winnereventdic);
      let timeDiff = (new Date().getTime()) - winnereventdic.time;
      if(timeDiff < 14400000){
        winnereventdiccondition = false;
      }
    }
    if(winnereventdiccondition){
      utilService.getWinnerEventDicJson(new Date().getTime()).then((res) => {
        if (!!res) {
          let winnereventdicres = res;
          winnereventdicres.time = new Date().getTime();
          localStorage.setItem("winnereventdic", JSON.stringify(winnereventdicres));
        }
      })
      // .catch((e) => { 
      //   console.log(e);
      // });
    }
  }

  componentWillUnmount() {
    localStorage.removeItem("SocialMedia");
  }

  getOperatorSocialMediaListData = async () => {
    await utilService
      .getOperatorSocialMediaJson()
      .then((response) => {
        let activeTab = "";
        if (
          response?.ALLPAGEDISPLAYWHATSAPP !== "" ||
          response.ALLPAGEDISPLAYTELEGRAM !== ""
        ) {
          activeTab = "messangerSection";
        } else {
          activeTab = "feedbackSection";
        }
        if (!!response && !!Object.keys(response).length > 0) {
          localStorage.setItem("SocialMedia", JSON.stringify(response));
          this.setState({ socialMedia: response });
        }
      })
      .catch((error) => {
        console.log("get operator banner list api error", error);
      });
  };

  logoutFnCall() {
    // authUtil.logout();

    // let appType = localStorage.getItem("appType");
    let rememberData = localStorage.getItem("rememberData");
    localStorage.clear();

    let accesControl = {
      sports: true,
      binary: true,
      casino: true,
    };
    localStorage.setItem("rememberData", rememberData);
    localStorage.setItem("accessControl", JSON.stringify(accesControl));
    window.location.href = window.location.origin;
  }
  showSweetAlert(options) {
    MySwal.fire(options);
    // .then(() => {
    //   return MySwal.fire(<p>Shorthand works too</p>)
    // })
  }

  toggleWhatsAppSupportDiv() {
    var element = document.getElementById("dvWhatsAppSupport");
    if (element.classList.contains("right0")) {
      element.classList.remove("right0");
    } else {
      element.classList.add("right0");
    }
  }

  toggleFeedbackSupportDiv() {
    var element = document.getElementById("dvFeedbackSupport");
    if (element.classList.contains("right0")) {
      element.classList.remove("right0");
    } else {
      element.classList.add("right0");
    }
  }
  render() {
    const notify = (msg, type, opt = null) => {
      if(!!opt){
        toast[type.toLowerCase() === "warning" ? "warn" : type.toLowerCase()](msg, opt);  
      } else {
        toast[type.toLowerCase() === "warning" ? "warn" : type.toLowerCase()](msg);
      }
    }
    const accData = JSON.parse(localStorage.getItem("accountData"));
    // toast.info("Lorem ipsum dolor");
    // toast.error("Lorem ipsum dolor")
    // toast.success("Lorem ipsum dolor")
    // toast.warn("Lorem ipsum dolor")
    return (
      <>
        {!this.state.inMaitanence ? (
          <>
            {TOPHEADERDOWNLOADAPKBNNR && this.state.showTopHeaderApkDwnld && (
              <div className="apkbox">
                <div
                  className="apkinner-left"
                  onClick={() => {
                    window.location.href = `https://apk.staticcontent.io/${APK_FILE_NAME}.apk`;
                  }}
                >
                  <div className="apkingdiv">
                    {" "}
                    <img
                      src={BASE_IMAGE_PATH + "/casino/img/apkicon.webp"}
                      alt={""}
                    ></img>
                  </div>
                  <div>
                    <div className="apk-title">
                      Download Android Application
                    </div>
                    <div className="apk-title-small">
                      Instant Download on your device
                    </div>
                  </div>
                </div>
                <div className="apkinner-right">
                  <div
                    className="install"
                    onClick={() => {
                      window.location.href = `https://apk.staticcontent.io/${APK_FILE_NAME}.apk`;
                    }}
                  >
                    Install
                  </div>
                  <div
                    className="apkclose"
                    onClick={() =>
                      this.setState({ showTopHeaderApkDwnld: false })
                    }
                  >
                    X
                  </div>
                </div>
              </div>
            )}
            <Route
              socket={socket}
              showSweetAlert={(title, text) => this.showSweetAlert(title, text)}
              MySwal={MySwal}
              notify={notify}
            />
            {/* FEEDBACK MENU */}
            {!(!!accData && Object.keys(accData).length > 0) &&
              !!this.state.socialMedia &&
              ((!!this.state.socialMedia?.ALLPAGEDISPLAYFEEDBACKWHATSAPPT &&
                this.state.socialMedia?.ALLPAGEDISPLAYFEEDBACKWHATSAPPT !==
                  "") ||
                (!!this.state.socialMedia?.ALLPAGEDISPLAYFEEDBACKEMAIL &&
                  this.state.socialMedia?.ALLPAGEDISPLAYFEEDBACKEMAIL !==
                    "")) && (
                <div id="dvFeedbackSupport">
                  <a
                    href="#"
                    className="switcher-toggle"
                    onClick={() => this.toggleFeedbackSupportDiv()}
                  >
                    <span className="poll-switcher">
                      <span className="pollhide">FEEDBACK</span>
                    </span>
                    <span className="pollicon">
                      <i className="fa fa-comments"></i>
                    </span>
                  </a>
                  <div className="style-switcher-wrap">
                    {!!this.state.socialMedia
                      ?.ALLPAGEDISPLAYFEEDBACKWHATSAPPT &&
                      this.state.socialMedia
                        ?.ALLPAGEDISPLAYFEEDBACKWHATSAPPT !== "" && (
                        <div>
                          <a
                            className="account-opening-img mb-15"
                            href={
                              this.state.socialMedia
                                ?.ALLPAGEDISPLAYFEEDBACKWHATSAPPT
                            }
                            target="_blank"
                            rel="noreferrer"
                          >
                            <img
                              src={`${BASE_IMAGE_PATH}/casino/banner/images/feedbackwhatsapp.png`}
                              alt=""
                            />
                          </a>
                        </div>
                      )}
                    {!!this.state.socialMedia?.ALLPAGEDISPLAYFEEDBACKEMAIL &&
                      this.state.socialMedia?.ALLPAGEDISPLAYFEEDBACKEMAIL !==
                        "" && (
                        <div>
                          <a
                            className="account-opening-img"
                            href={
                              this.state.socialMedia
                                ?.ALLPAGEDISPLAYFEEDBACKEMAIL
                            }
                            target="_blank"
                            rel="noreferrer"
                          >
                            <img
                              src={`${BASE_IMAGE_PATH}/casino/banner/images/feedbackemail.png`}
                              alt=""
                            />
                          </a>
                        </div>
                      )}
                    {/* <button type="submit" className="btn btn-bordered btn-primary btn-sm">Vote</button> */}
                  </div>
                </div>
              )}
            {/* FEEDBACK END */}

            {/* MENU */}
            {!(!!accData && Object.keys(accData).length > 0) &&
              !!this.state.socialMedia &&
              ((!!this.state.socialMedia?.ALLPAGEDISPLAYWHATSAPPSUPPORT &&
                this.state.socialMedia?.ALLPAGEDISPLAYWHATSAPPSUPPORT !== "") ||
                (!!this.state.socialMedia?.ALLPAGEDISPLAYWHATSAPPACCOUNT &&
                  this.state.socialMedia?.ALLPAGEDISPLAYWHATSAPPACCOUNT !==
                    "")) && (
                <div id="dvWhatsAppSupport">
                  <a
                    href="#"
                    className="switcher-toggle"
                    onClick={() => this.toggleWhatsAppSupportDiv()}
                  >
                    <span className="poll-switcher">
                      <span className="pollhide">Whatsapp</span>
                    </span>
                    <span className="pollicon">
                      <i className="fa fa-whatsapp"></i>
                    </span>
                  </a>
                  <div className="style-switcher-wrap">
                    {!!this.state.socialMedia?.ALLPAGEDISPLAYWHATSAPPACCOUNT &&
                      this.state.socialMedia?.ALLPAGEDISPLAYWHATSAPPACCOUNT !==
                        "" && (
                        <div>
                          <a
                            className="account-opening-img mb-15"
                            href={
                              this.state.socialMedia
                                ?.ALLPAGEDISPLAYWHATSAPPACCOUNT
                            }
                            target="_blank"
                            rel="noreferrer"
                          >
                            <img
                              src={`${BASE_IMAGE_PATH}/casino/banner/images/account-opening-icon-img.png`}
                              alt=""
                            />
                          </a>
                        </div>
                      )}
                    {!!this.state.socialMedia?.ALLPAGEDISPLAYWHATSAPPSUPPORT &&
                      this.state.socialMedia?.ALLPAGEDISPLAYWHATSAPPSUPPORT !==
                        "" && (
                        <div>
                          <a
                            className="account-opening-img"
                            href={
                              this.state.socialMedia
                                ?.ALLPAGEDISPLAYWHATSAPPSUPPORT
                            }
                            target="_blank"
                            rel="noreferrer"
                          >
                            <img
                              src={`${BASE_IMAGE_PATH}/casino/banner/images/support-icon-img.png`}
                              alt=""
                            />
                          </a>
                        </div>
                      )}
                    {/* <button type="submit" className="btn btn-bordered btn-primary btn-sm">Vote</button> */}
                  </div>
                </div>
              )}
            {/* MENU END */}

            <ToastContainer
              theme="colored"
              autoClose={3000}
              pauseOnHover={false}
            />
            {!(!!accData && Object.keys(accData).length > 0) &&
              (!!this.state.socialMedia &&
              !!this.state.socialMedia?.ALLPAGEDISPLAYWHATSAPP &&
              this.state.socialMedia?.ALLPAGEDISPLAYWHATSAPP !== "" ? (
                <Draggable
                  cancel={this.state.clientWidth <= 768 ? ".whats-apps" : ""}
                >
                  <div className="whatsapp-draggable">
                    <a
                      className="whats-apps"
                      href={this.state.socialMedia?.ALLPAGEDISPLAYWHATSAPP}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        src={`${BASE_IMAGE_PATH}/casino/banner/images/whatsapp-icon-new.png`}
                        alt=""
                      />
                    </a>

                    {/* <div className='whtsapp-lp whatsapp-texthide'>
                      <div className='innertext-whatsapp'>Get an ID Instantly on Whatsapp</div>
                      <a href='#'>Click Here Now</a>
                    </div> */}
                  </div>
                </Draggable>
              ) : (
                !!this.state.socialMedia &&
                !!this.state.socialMedia?.ALLPAGEDISPLAYTELEGRAM &&
                this.state.socialMedia?.ALLPAGEDISPLAYTELEGRAM !== "" && (
                  <Draggable
                    cancel={this.state.clientWidth <= 768 ? ".whats-apps" : ""}
                  >
                    <div className="whatsapp-draggable">
                      <a
                        className="whats-apps"
                        href={this.state.socialMedia?.ALLPAGEDISPLAYTELEGRAM}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img
                          src={`${BASE_IMAGE_PATH}/casino/banner/images/telegram-icon.png`}
                          alt=""
                        />
                      </a>

                      <div className="tlgrm-lp telegram-texthide">
                        <div className="innertext-telegram">
                          Get an ID Instantly on telegram
                        </div>
                        <a href="#">Click Here Now</a>
                      </div>
                    </div>
                  </Draggable>
                )
              ))}
          </>
        ) : (
          <UnderMaintenance
            inMaitanenceMessage={this.state.inMaitanenceMessage}
          />
        )}
      </>
    );
  }
}
function mapStateToProps(state, ownProps) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {};
}
export default connect(mapStateToProps, mapDispatchToProps)(App); //(Sentry.withProfiler(App));
